import {
	addressConstants, preAppConstants
} from 'store';

var initialState = {
	loading: false,
	error: null,
}

export function address(state = initialState, action) {
	switch (action.type) {
		case preAppConstants.RESET_APPLICATION_STATE:
			return {
				...initialState,
			};
		case addressConstants.SEND_ADDRESS_REQUEST:
			return {
				...state,
				loading: true,
			};
		case addressConstants.SEND_ADDRESS_SUCCESS:
			return {
				...state,
				loading: false,
			};
		case addressConstants.SEND_ADDRESS_ERROR:
			return {
				...state,
				error: action.error,
				loading: false,
			};
		default:
			return state
	}
}